import { toast } from 'react-toastify';
import { uploadFile } from 'shared/api/uploadFile';
import { useRetryableAction } from 'shared/hooks/useRetryableAction';
import { getErrorMessage } from 'shared/utils/errorMessage';
import { showErrorToastWithRetry } from 'shared/utils/showErrorToastWithRetry';

export const useUploadFile = () => {
  const { execute, isLoading } = useRetryableAction(
    (formData) => uploadFile(formData),
    {
      onError: (error, { isRetryExhausted, status }) => {
        const message = getErrorMessage(error);
        if (status >= 500 && isRetryExhausted) {
          showErrorToastWithRetry(`Upload file: ${message}`, () => execute());
        } else {
          toast.error(`Upload file: ${message}`);
        }
      },
    }
  );

  return { handleUpload: execute, loading: isLoading };
};
